<template>
    <div class="mt-3 mb-3" v-html="$t('messages.sale_info_send_mail')"></div>
    <!-- <ValidationObserver v-slot="{ handleSubmit }">
        <form
            @submit.prevent="handleSubmit(downloadCode)"
            class="flex flex-col w-full py-4 md:px-4"
        >
            <div id="OptParque" class="form-folio">
                <div class="flex -mx-2">
                    <div class="my-2 mx-2 w-1/2">
                        <ValidationProvider
                            :name="$t('Forms.choose_park')"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label
                                class="font-bold"
                                :for="$t('Forms.choose_park')"
                                >{{ $t("Forms.choose_park") }}:</label
                            >
                            <select
                                v-model="GetPhotos.ParkId"
                                :name="$t('Forms.choose_park')"
                                class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                            >
                                <option
                                    :value="null"
                                    selected="selected"
                                    disabled="disabled"
                                >
                                    {{ $t("Forms.choose_option") }}
                                </option>

                                <template v-for="(item, idx) in GetParks">
                                    <option
                                        :key="idx"
                                        :value="item.ParkId"
                                        v-html="item.ParkName"
                                        v-if="!item.IsHotel"
                                    ></option>
                                </template>
                            </select>
                            <p class="txt-error text-red text-xs italic mb-2">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>

                    <div class="my-2 mx-2 w-1/2">
                        <ValidationProvider
                            :name="$t('Forms.visit_date')"
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <label
                                class="font-bold"
                                :for="$t('Forms.visit_date')"
                                >{{ $t("Forms.visit_date") }}:</label
                            >
                            <date-picker
                                v-model="GetPhotos.visitDate"
                                type="date"
                                placeholder="YYYY-MM-DD"
                                :default-value="new Date()"
                                :disabled-date="
                                    disabledBeforeTodayAndAfterAWeek
                                "
                                value-type="format" 
                                format="YYYY-MM-DD"
                                :editable="false"
                            >
                            </date-picker>
                            <p class="txt-error text-red text-xs italic mb-2">
                                {{ errors[0] }}
                            </p>
                        </ValidationProvider>
                    </div>
                </div>

                <ValidationProvider
                    :name="$t('Forms.bracelet_hull_subgroup')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label
                        class="font-bold"
                        :for="$t('Forms.bracelet_hull_subgroup')"
                        >{{ $t("Forms.bracelet_hull_subgroup") }}:
                    </label>

                    <multiselect
                    v-model="tagList"
                    :name="$t('Forms.bracelet_hull_subgroup')"
                    :options="options"
                    :multiple="true"
                    :taggable="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :hide-selected="true"
                    :allow-empty="true"
                    :showNoResults="false"
                    :showNoOptions="false"
                    open-direction="bottom"
                    :limit="15"
                    :tagPlaceholder="$t('Forms.add_tag')"
                    :selectLabel="$t('Forms.press_enter_select')"
                    placeholder=""
                    @tag="addTag"
                    />
                    <p class="txt-error text-red text-xs italic mb-2">
                        {{ errors[0] }}
                    </p>
                </ValidationProvider>                
            </div>

            <button
                type="submit"
                class="w-full flex justify-center rounded-full py-3 px-4 mb-1 mt-2 bg-red-500 text-white cursor-pointer font-semibold mx-auto"
            >
                {{ $t("Forms.add_code") }}
            </button>
        </form>
    </ValidationObserver> -->
</template>

<script>
import { GetApiErrorMessage } from "@helpers/apiErrorHelper";
import { NormalizeTag } from "@helpers/tagHelper";
let code = document.documentElement.lang;
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "../validators/index";
import moment from "moment";
import AlbumsByTagMix from "../mixins/albums/GetAlbumsByTag";
import methodUser from "../mixins/methodUser";
import cartMx from "../mixins/Cart";
import Multimedia from "../mixins/Multimedia";

import Multiselect from 'vue-multiselect';

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";
DatePicker.locale(code)

export default {
    props: [],
    mixins: [AlbumsByTagMix, methodUser, Multimedia, cartMx],
    components: {
        DatePicker, Multiselect
    },
    data: () => ({
        firstName: "",
        lastName: "",
        email: "",
        errors: [],
        downloadCodes: [],
        option: 0,
        loading: false,
        screenLoading: false,
        lastInsertItem: [],
        GetPhotos: {
            question: "",
            JoinedCode: "",
            ParkId: null,
            visitDate: "",
            tag: "",
            HotelId: null,
            Room: "",
            ArrivalDate: "",
            DepartureDate: "",
        },
        Parks: [{ value: null, text: "Seleccione una opción" }],
        Hotels: [{ value: null, text: "Seleccione una opción" }],
        tagList: [],
        options: [],
    }),
    computed: {
        GetParks() {
            return this.$store.getters.GetParks;
        },
        DateGood() {
            this.formatDate(this.GetPhotos.ArrivalDate);
        },
    },
    methods: {
        /*
        * @description: Metodo para agregar un nuevo tag
        * @param: newTag
        */
        addTag(newTag) {
            const tag = NormalizeTag(newTag);

            if (!tag) {
                Vue.$toast.open({
                    message: "Tag inválido",
                    type: "error",
                });
                return;
            }

            if (tag.length > 25) {
                Vue.$toast.open({
                    message: "Máximo 25 caracteres",
                    type: "error",
                });
                return;
            }

            this.tagList.push(tag);
        },
        formatDate(date) {
            return moment(String(date)).format("YYYY-MM-DD");
        },
        hasCode() {
            // Verificamos si el tag fue agregado anteriormente
            return Object.values(this.$store.state.albumes).some(element => element.code == this.GetPhotos.tag && element.Type == 1);
        },
        async downloadCode() {
            try {
                this.msgApi.error = false;
                this.msgApi.message = "";
                this.$store.dispatch("setLoading", true);

                
                if (this.hasCode()) {
                    Vue.$toast.open({
                        message: this.$t("Forms.exist_code"),
                        type: "info",
                    });

                    this.$store.dispatch("setLoading", false);
                    this.msgApi.error = true;
                    this.msgApi.message = this.$t("Forms.exist_code");

                    return;
                }

                let tagList = this.tagList;
                const parkId = parseInt(this.GetPhotos.ParkId);
                const visitDate = this.GetPhotos.visitDate.toString();
                tagList = this.GroupParksByDate(tagList, visitDate, parkId);

                await this.GetAlbumByTag(tagList, parkId, visitDate);
                // Close modal add new Tag
                this.$store.dispatch("setModalAddAlbum", false);
                
            } catch (error) {
                const message = GetApiErrorMessage(
                    error,
                    this.$t("messages.album_error_add")
                );
                this.msgApi.message = message;

                Vue.$toast.open({
                    message,
                    type: "error",
                });

                this.$store.dispatch("setLoading", false);
                this.msgApi.error = true;  
            }
        },
        saveDownloadCode(data) {
            let newCodes;
            let currentCode = "";
            let recoveredData = this.getAlbumes;

            if (this.GetPhotos.question == 1) {
                currentCode = this.GetPhotos.tag;
                newCodes = {
                    code: this.GetPhotos.tag,
                    type: this.GetPhotos.question,
                    visitDate: this.GetPhotos.visitDate,
                    ParkId: this.GetPhotos.ParkId,
                };
            } else if (this.GetPhotos.question == 2) {
                currentCode = this.GetPhotos.Room;
                newCodes = {
                    code: this.GetPhotos.Room,
                    type: this.GetPhotos.question,
                    ArrivalDate: this.GetPhotos.ArrivalDate,
                    DepartureDate: this.GetPhotos.DepartureDate,
                    ParkId: this.GetPhotos.HotelId,
                };
            } else {
                currentCode = this.GetPhotos.JoinedCode;
                newCodes = {
                    code: this.GetPhotos.JoinedCode,
                    type: this.GetPhotos.question,
                };
            }

            if (recoveredData == null || !recoveredData.length) {
                this.setCodes(newCodes);
                this.GetPhotos.JoinedCode = "";

                return false;
            } else {
                //Asegurate que lo que guardes es realmente un array.
                if (!this.existCode(recoveredData, currentCode)) {
                    this.setCodes(newCodes);
                    this.GetPhotos.JoinedCode = "";
                    
                    return false;
                } else {
                    return true;
                }
            }
        },
        existCode(data, valueFind) {
            let exist = false;
            data.map(function (item) {
                if (item.code == valueFind) exist = true;
            });

            return exist;
        },
        onChangeQuestion(event) {},
        // Metodos para agregar los codigos a un arreglo.
        addDownloadCode() {
            this.downloadCodes.push(this.GetPhotos.JoinedCode);
            this.GetPhotos.JoinedCode = "";
        },
        clearFormSearch() {
            this.GetPhotos.JoinedCode = "";
            this.GetPhotos.ParkId = null;
            this.GetPhotos.visitDate = "";
            this.GetPhotos.tag = "";
            this.HotelId = null;
            this.Room = "";
            this.ArrivalDate = "";
            this.DepartureDate = "";
        },
    },
    created() {},
    mounted() {},
};
</script>
